import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/withdraw-units`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const withdrawUnits = {
  post: apiPathFunc(pathBase),
};
